/**
 * Cart Locale Redirect
 * Removes locale prefix from URL for specific locale/market combinations
 */
(function() {
  'use strict';

  // Configuration: locale -> array of possible market handles
  const localeConfig = {
    'it': ['italy', 'it'],
    'fr': ['france', 'fr'],
    'de': ['germany', 'de']
  };

  // Get locale and market from data attributes on container
  const container = document.querySelector('.container[data-cart-locale]');
  if (!container) return;

  const locale = container.getAttribute('data-cart-locale');
  const marketHandle = container.getAttribute('data-cart-market');

  // Check if locale is in our configuration
  const allowedMarkets = localeConfig[locale];
  if (!allowedMarkets) {
    return;
  }

  // Check if market handle matches any of the allowed values
  const isMarketValid = allowedMarkets.some(market => market === marketHandle);
  if (!isMarketValid || marketHandle === 'N/A') {
    return;
  }

  // Build regex pattern for locale prefix (e.g., /it/, /fr/, /de/)
  const localePrefix = '/' + locale;
  const localePrefixRegex = new RegExp('^' + localePrefix.replace('/', '\\/') + '(\\/|$)');

  const currentPath = window.location.pathname;
  
  // Check if URL contains locale prefix
  if (localePrefixRegex.test(currentPath)) {
    // Remove locale prefix from the path
    let newPath = currentPath.replace(localePrefixRegex, '/');
    
    // Ensure we have at least a slash
    if (newPath === '') {
      newPath = '/';
    }
    
    // Build new URL
    const newUrl = window.location.origin + newPath + window.location.search + window.location.hash;
    
    // Redirect to new URL
    window.location.replace(newUrl);
  }
})();

